import React from 'react'
import './loader.css'

function Loader() {
  return (
    <div className="loading__container">
      <svg id="logo" width="270" height="270" viewBox="0 0 270 270" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M265 135C265 206.797 206.797 265 135 265C63.203 265 5 206.797 5 135C5 63.203 63.203 5 135 5C206.797 5 265 63.203 265 135Z"
        stroke="white" strokeWidth="10" />
      <path
        d="M123.785 83.425H123.682V88.425V135.088L101 95.1258L96.3567 86.9441V83.425H94.3594L91.652 78.6549V83.425H91.3567H75.6H70.6V88.425V183.6V188.6H75.6H91.3567H96.3567V183.6V136.889L123.785 185.104V188.6H125.774H128.682H128.785H144.439H144.542H144.837H149.439H149.542H149.837H188.325H193.325V183.6V171.848V166.848H188.325H149.837H149.542V145.726H149.837H184.321H189.321V140.726V130.137V125.137H184.321H149.837H149.542V105.177H149.837H188.325H193.325V100.177V88.425V83.425H188.325H149.837H149.542H149.439H144.837H144.542H144.439H128.785H128.682H123.785Z"
        stroke="white" strokeWidth="10" />
      <path d="M127.869 76.675L128.662 75.7679L129.456 76.675H127.869Z" stroke="white" strokeWidth="10" />
    </svg>
    </div>
  )
}

export default Loader
